module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-icon-cake-78b3d84fbc932be532386b6a1450a425.png";